class TestimonialsSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    // Wait for Swiper to be available (since it is loaded with defer)
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.initSwiper(), 50);
      return;
    }

    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) return;

    this.swiperInstance = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      mousewheel: {
        forceToAxis: true,
      },
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
  }
}

if (!customElements.get('testimonials-swiper')) {
  customElements.define('testimonials-swiper', TestimonialsSwiper);
}
